import Box from '@mui/material/Box';
import React from 'react';

const wrapperSx = {
  display: 'flex',
  flexDirection: 'column',
  width: 'auto',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  height: '100vh',
  overflow: 'auto',
};

const PublicPageWrapper = ({ children }) => (
  <Box sx={wrapperSx} component="main">
    {children}
  </Box>
);

export default PublicPageWrapper;
